import { useFormContext } from "react-hook-form";
import { cn } from "@patient-watch/ui";
import { Checkbox as UICheckbox } from "@patient-watch/ui/checkbox";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@patient-watch/ui/form";
import { RichLabel } from "./components/RichLabel";

interface Props {
    label?: string;
    name: string;
    description?: string;
    required?: boolean;
}

const Checkbox = ({ label, name, description, required = false }: Props) => {
    const { control } = useFormContext();

    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    <FormControl>
                        {/*
                          Sibling label + control (not nested). Nesting a Radix checkbox button
                          inside <label htmlFor> double-toggles in real browsers.
                        */}
                        <div
                            className={cn(
                                "flex items-start gap-4 py-2 pl-2 rounded-lg w-full text-left transition-all"
                            )}
                        >
                            <UICheckbox
                                checked={field.value}
                                onCheckedChange={field.onChange}
                                id={name}
                                className="mt-0.5 rounded-md w-8 h-8 shrink-0"
                            />
                            <label htmlFor={name} className="min-w-0 flex-1 space-y-1 cursor-pointer">
                                {label && (
                                    <span className="block font-normal text-sm leading-snug text-slate-700 dark:text-slate-200">
                                        <RichLabel>{label}</RichLabel>
                                        {required && <span className="ml-0.5 text-red-500">*</span>}
                                    </span>
                                )}
                                {description && <FormDescription>{description}</FormDescription>}
                            </label>
                        </div>
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    );
};

export default Checkbox;
